import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from '../Components/HomePage/HomePage'
import Thanks from '../Tools/Thanks/Thanks'
import BookAnAppointment from '../Components/BookAnAppointment/BookAnAppointment'
import ThanksContact from '../Tools/ThanksContact/ThanksContact'
import PrivacyPolicy from '../Tools/PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from '../Tools/TermsAndConditions/TermsAndConditions'
import AirDuct from '../Components/AirDuct/AirDuct'
import Dryer from '../Components/Dryer/Dryer'
import HVAC from '../Components/HVAC/HVAC'
import Chimney from '../Components/Chimney/Chimney'
import Roofing from '../Components/Roofing/Roofing'

export default function Main({ CitiePhone, CitiesData, navigateTo, locationsMain }) {

    return (
        // <div>
        <Routes>
            <Route path="/" element={<HomePage locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/airduct" element={<AirDuct locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/dryer" element={<Dryer locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/hvac" element={<HVAC locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/chimney" element={<Chimney locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/roofing" element={<Roofing locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/book" element={<BookAnAppointment CitiesData={CitiesData}  CitiePhone={CitiePhone} />} />
            <Route path="/thanks" element={<Thanks CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/thankscontact" element={<ThanksContact CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
             {/* Privacy Policy */}
             <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
        </Routes>
        // </div>
    )
}
